<!-- The progressbar that is shown above questions -->
<template>
    <div progressbarfooter aria-live="assertive">
        <div data-bar>
            <svg data-ring viewBox="0 0 110 110" aria-hidden="true">
                <circle data-ring-track cx="55" cy="55" :r="ringRadius" />
                <circle
                    data-ring-progress
                    cx="55"
                    cy="55"
                    :r="ringRadius"
                    :style="progressCircleStyle"
                />
            </svg>
            <span data-only-screenreader>{{this.$store.getters.textResource(`rs_progress`)}}</span>
            <p v-if="layout.ProgressBar.ShowPercentageBottom === true" data-value-label>{{ progressPercentage }}%</p>
        </div>
    </div>
</template>

<script>
export default {
    name: `progress-bar-footer`,
    computed: {
        state: function () {
            return this.$store.state;
        },
        progressPercentage: function () {
            let page = this.state.page;
            if (page === undefined) return 0;

            let progress = parseInt(page.progress);

            if (progress < 0) return 0;
            else if (progress > 100 || isNaN(progress)) return 100;
            return progress;
        },
        layout: function () {
            return this.state.layout;
        },
        ringRadius: function () {
            return 53;
        },
        ringCircumference: function () {
            return 2 * Math.PI * this.ringRadius;
        },
        progressCircleStyle: function () {
            return {
                strokeDasharray: `${this.ringCircumference}`,
                strokeDashoffset: `${this.ringCircumference * (1 - this.progressPercentage / 100)}`,
            };
        },
    },
};
</script>

<style scoped>
[progressbarfooter] {
    display: flex;
    justify-content: center;
    justify-self: center;
    align-items: center;
    min-width: 80px;
    position: relative;
    padding: 0;
    margin-inline: 20px;
}

[progressbarfooter] [data-bar] {
    border-radius: 50%;
    height: 80px;
    width: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

[progressbarfooter] [data-ring] {
    inset: 0;
    position: absolute;
    overflow: visible;
}

[progressbarfooter] [data-ring-track],
[progressbarfooter] [data-ring-progress] {
    fill: none;
    stroke-width: 4;
    transform: rotate(-90deg);
    transform-origin: 55px 55px;
}

[progressbarfooter] [data-ring-track] {
    stroke: #E3E4E8;
}

[progressbarfooter] [data-ring-progress] {
    stroke: var(--primary-color);
    stroke-linecap: round;
    transition: stroke-dashoffset 0.5s ease-out;
}

[progressbarfooter] [data-value-label] {
    background: transparent;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    padding: 0;
    text-align: center;
    width: 78px;
    height: 78px;
    font-size: 18px;
    font-family: var(--page-font-family-public-name);
    color: var(--progresspercentage-color);
    margin: 0;
}

</style>